import { Dispatch, createSlice } from "@reduxjs/toolkit";
import { TRequestStatus } from "@models/msc.model";
import { TCalendar } from "@/models/calendar.model";
import calendarService from "@/services/calendar.service";
import { RootState } from "..";

type CalendarsState = {
  initialized: boolean;
  status: TRequestStatus;
  calendars: TCalendar[];
};

//-----THUNK FUNCTIONS-----

const initialState: CalendarsState = {
  initialized: false,
  status: "IDLE",
  calendars: [],
};

const calendarsSlice = createSlice({
  name: "calendars",
  initialState,
  reducers: {
    startLoading(state) {
      state.status = "PENDING";
    },
    rollback(state, actions) {
      state.status = "IDLE";
      state.calendars = actions.payload;
    },
    gotCalendars(state, action) {
      state.calendars = action.payload;
      state.status = "IDLE";
      state.initialized = true;
    },
    calendarCreated(state, action) {
      state.calendars = [action.payload, ...state.calendars];
    },
    calendarRemoved(state, action) {
      state.calendars = state.calendars.filter((calendar) => calendar.id !== action.payload);
    },
    calendarUpdated(state, action) {
      state.calendars = state.calendars.map((calendar) =>
        calendar.id === action.payload.id ? action.payload : calendar
      );
    },
  },
});

// ----------------------------

export const getAllCalendars = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const {
    calendars: { calendars, initialized },
  } = getState();

  if (initialized) return calendars;

  dispatch(calendarsSlice.actions.startLoading());
  const response = await calendarService.getAllCalendars();
  dispatch(calendarsSlice.actions.gotCalendars(response));
  return response;
};

// ----------------------------

export const createFormCalendar = (formId: number) => async (dispatch: Dispatch) => {
  const response = await calendarService.saveFormCalendar(formId);
  dispatch(calendarsSlice.actions.calendarCreated(response));
  return response;
};

// ----------------------------

export const removeCalendar = (calendarId: number) => async (dispatch: Dispatch) => {
  const response = await calendarService.removeCalendar(calendarId);
  dispatch(calendarsSlice.actions.calendarRemoved(calendarId));
  return response;
};

// ----------------------------

export const updateCalendar = (calendar: TCalendar) => async (dispatch: Dispatch) => {
  const response = await calendarService.updateCalendar(calendar);
  dispatch(calendarsSlice.actions.calendarUpdated(calendar));
  return response;
};

export default calendarsSlice.reducer;
